// extracted by mini-css-extract-plugin
module.exports = {"header":"index-module--header--239p4","title":"index-module--title--1o-T5","nav":"index-module--nav--36zix","logo":"index-module--logo--1kTSE"};